import { render, staticRenderFns } from "./StopLossRecord.vue?vue&type=template&id=672110ba&"
import script from "./StopLossRecord.vue?vue&type=script&lang=js&"
export * from "./StopLossRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports